var interpolateNumber = function (from, to, k) {
    if (isNaN(from)) {
        return to;
    }
    return from + (to - from) * k;
};
export default interpolateNumber;
